import { watch } from 'vue';

/*
    Code which handles QUERY PARAM functionality
*/
export function useParams(
    categoriesStore,
    paginatedListingsQuery,
    queryParams,
    resultsStore,
    routing,
    settings,
    useFetch,
    config,
) {

    let resultsTimeout;

    /*
        This is the function that updates our paginated listings
    */
    async function getResults() {

        clearTimeout(resultsTimeout);

        /*
            setting a timeout so that we don't fire off
            multiple requests (e.g. if the visitor has altered
            multiple filters in very quick succession, or we
            are updating via keyup in a text input field)
        */
        resultsTimeout = setTimeout(function () {

            /*
                count the number of active queries - we only want
                to update the listing results when the FINAL query
                is returned
            */
            resultsStore.incrementActiveQueries();

            const params = {
                ...queryParams.params,
                ...getDefaultParams()
            };

            useFetch({
                url: settings['host'],
                apiKey: settings['key'],
                query: paginatedListingsQuery(params),
                callback: resultsStore.updateResults,
            });

        }, 200);

    };

    /**
     * Gets the default params for the graphql query
     *
     * Prevents the default query params from showing in the url
     *
     * @returns {Object} - The default params
     */
    function getDefaultParams() {

        const params = {};

        if (queryParams.params.categories.length === 0) {

            if (categoriesStore.chosenTopLevelCategory) {

                params.categories = [categoriesStore.chosenTopLevelCategory];

            } else {

                params.categories = settings.categories;

            }

        }

        if (!queryParams.params.places.length) {

            params.places = [];

            if (settings.locations) {
                params.places = settings.locations;
            }

            if (settings.region) {
                params.places.push(settings.region);
            }

        }

        if (!queryParams.params.facets.length) {

            params.facets = [];

            if (settings.facets) {
                params.facets = settings.facets;
            }

        }

        if (queryParams.params.imageWidth === 0) {
            params.imageWidth = config.imageWidth;
        }

        if (queryParams.params.imageHeight === 0) {
            params.imageHeight = config.imageHeight;
        }

        if (settings.mapSvgIconClasses) {
            params.mapIconExtraClasses = settings.mapSvgIconClasses
        }

        if (settings.pageLimit) {
            params.limit = settings.pageLimit;
        }

        return params;
    }

    /*
        Every time the query params change, we need more results
    */
    function watchParams() {
        watch(queryParams.params, () => {

            routing.updateUrlFromParams(
                queryParams.params,
                categoriesStore,
            );

            getResults();

        });
    }

    return {
        getResults,
        watchParams,
    }

}
